<template>
<div class="chapter">
<div class="inner_page">
<h3 class="P_TOC_Heading"><a id="tableofcontents">Table of Contents</a></h3><a id="tableofcontents">
</a><p class="P_TOC_Entry_1"><a id="tableofcontents"></a><a href="#/section0001">Title Page</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0002">Other Anthologies Edited by:</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003">Dragonesque</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004">Copyright © 2023 S.C. Butler, Joshua Palmatier, and</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005">Copyrights</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006">SLAY</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007">AVARICE AND VENGEANCE</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008">THE PRINCESS NETWORK</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009">COLD FIRE OF MANHATTAN</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010">DUCK, DUCK, DRAGON</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011">SHEEP RARELY WEAR GOLD</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012">THE EXPOSÉ</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013">LORD BAI AND THE MAGIC PIRATE</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014">TATSU: CRYO FIVE</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015">A KING ARTHUR DRAGON IN SPACE STATION 23’S COURT</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016">MIGRATION SEASON</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017">BONE AND BLOOD</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018">THE BREEDING HABITS OF DRAGONS</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019">GODS IN CHAINS</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020">THE LEFT HAND OF GIORDINO</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0021">REENACTMENT</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0022">ABOUT THE AUTHORS</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0023">ABOUT THE EDITORS</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0024">ACKNOWLEDGMENTS</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TableOfContents.vue?6942ffbc